module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view",
    attrs: {
      "id": "spot"
    }
  }, [(_vm.browsing === false) ? _c('div', {
    staticClass: "content",
    attrs: {
      "id": "choose"
    }
  }, [_c('div', {
    staticClass: "inside-closer",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("✖")]), _vm._v(" "), _c('div', {
    staticClass: "sub-heading padding-20"
  }, [_vm._v("Fotoplats")]), _vm._v(" "), _c('div', {
    staticClass: "heading"
  }, [_c('div', {
    staticClass: "blue-circle"
  }), _vm._v(" " + _vm._s(_vm.atSpot[0]))]), _vm._v(" "), (_vm.atSpotWinner !== null) ? _c('div', {
    staticClass: "spot-winner padding-20 eye",
    style: ({
      backgroundImage: 'url(' + _vm.atSpotWinner.thumburl + ')'
    }),
    on: {
      "click": function($event) {
        _vm.$store.dispatch('viewSinglePhoto', _vm.atSpotWinner)
      }
    }
  }) : _c('div', {
    staticClass: "spot-winner padding-20"
  }, [_c('br'), _c('br'), _c('br'), _vm._v("Inget foto visas än, bli först!")]), _vm._v(" "), (_vm.atSpotWinner) ? _c('div', {
    staticClass: "sub-heading-list"
  }, [_c('div', {
    staticClass: "sub-heading"
  }, [_vm._v("Fotograf")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.atSpotWinner.username))]), _vm._v(" "), _c('div', {
    staticClass: "border"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [(_vm.userHasPhotoAtSpot === false) ? _c('a', {
    staticClass: "upload-button blue-butt",
    on: {
      "click": _vm.challangePhoto
    }
  }, [_vm._v("Ladda upp ditt bidrag")]) : _c('a', {
    staticClass: "upload-button blue-butt",
    on: {
      "click": _vm.challangePhoto
    }
  }, [_vm._v("Byt ut ditt foto")]), _vm._v(" "), _c('a', {
    staticClass: "black-on-white-butt browse",
    on: {
      "click": _vm.browsePhotos
    }
  }, [_vm._v("Se foton från platsen")])]), _vm._v(" "), _c('div', {
    staticClass: "padding-80"
  })]) : _c('div', {
    staticClass: "content",
    attrs: {
      "id": "browse"
    }
  }, [_c('div', {
    staticClass: "inside-closer",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("✖")]), _vm._v(" "), _c('div', {
    staticClass: "sub-heading padding-20"
  }, [_vm._v("Fotoplats")]), _vm._v(" "), _c('div', {
    staticClass: "heading"
  }, [_c('div', {
    staticClass: "blue-circle"
  }), _vm._v(" " + _vm._s(_vm.atSpot[0]))]), _vm._v(" "), _c('div', {
    staticClass: "sub-heading padding-40 pad-sides"
  }, [_vm._v("\n      Foton på platsen\n    ")]), _vm._v(" "), (_vm.atSpotPhotosLoaded === true) ? _c('div', {
    staticStyle: {
      "padding": "15px 0px"
    }
  }, [_c('photoFeed', {
    attrs: {
      "photos": _vm.atSpotPhotos,
      "show-user": "true",
      "show-spot": "false"
    }
  }, [_c('div', {
    slot: "empty"
  }, [_vm._v("No photos at spot.")])])], 1) : _c('div', [_c('loader', {
    attrs: {
      "colorClass": "black"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "padding-80"
  }), _vm._v(" "), _c('div', {
    staticClass: "padding-80"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e9ea9c8c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/spot.vue
// module id = 122
// module chunks = 0